import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import XIcon from 'icons/X.icon';
import { Button } from 'ncoded-component-library';

import './ResolveMultiSelctOption.styles.scss';

type ResolveMultiSelectOptionProps<T> = {
  className?: string;
  label: string;
  value: T;
  disabled?: boolean;
  onDelete: (val: T) => void;
};

function ResolveMultiSelctOption<T>(props: ResolveMultiSelectOptionProps<T>) {
  const { className, label, value, disabled, onDelete } = props;
  const { t } = useTranslation();

  const classes = classNames('resolve-multi-selct-option', className);

  return (
    <div className={classes}>
      {t(label)}
      <Button
        variant="icon"
        icon={XIcon}
        disabled={disabled}
        aria-label="Remove"
        onClick={(ev) => {
          ev.stopPropagation();
          onDelete(value);
        }}
      />
    </div>
  );
}

export default ResolveMultiSelctOption;
